<template>
    <v-card rounded class="crud-table bordered px-2 px-md-6 py-2 py-lg-3">
        <v-data-table :loading="loading" :headers="headers" :items="items" mobile-breakpoint="0" :hide-default-footer="serverPagination" :server-items-length="serverPagination ? perPage : undefined" class="e-data-table elevation-0 mb-4">
            <template v-slot:top>
                <div class="d-flex py-2">
                    <div class="d-flex align-center font-weight-medium" style="align-self: start; font-size: 1.15rem;">
                        <span>{{title}}</span>
                        <span class="muted--text medium-text ms-2">({{total}})</span>
                    </div>
                    <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
                    <v-spacer></v-spacer>
                    <div class="d-flex align-center mb-2">
                        <form v-if="showSearch && pcOnly" @submit.prevent="search">
                            <v-text-field ref="searchInput" width="200" type="search" :append-icon="searchQuery ? 'mdi-close' : 'mdi-magnify'" @click:append="reset" hide-details outlined label="البحث" :placeholder="searchPlaceholder" dense v-model="searchQuery"/>
                        </form>
                        <v-btn class="ms-6" v-if="!hideCreate" depressed color="primary" dark @click="$emit('create')">
                            <v-icon v-if="createButtonIcon" size="19" left>{{createButtonIcon}}</v-icon>
                            <span>{{createButtonText}}</span>
                        </v-btn>

                        <v-btn v-if="exportUrl" fab small dark color="green darken-2" depressed class="ms-2" @click="exportDialog = true">
                            <v-icon>mdi-file-export</v-icon>
                        </v-btn>
                    </div>
                </div>

                <form v-if="showSearch && phoneOnly" @submit.prevent="search" class="px-4 mb-4 mt-2">
                    <v-text-field ref="searchInput" width="200" type="search" :append-icon="searchQuery ? 'mdi-close' : 'mdi-magnify'" @click:append="reset" hide-details outlined label="البحث" :placeholder="searchPlaceholder" dense v-model="searchQuery"/>
                </form>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip label small :color="handleStatus(item.status).color" :dark="!!handleStatus(item.status).color">
                    {{handleStatus(item.status).text}}
                </v-chip>
            </template>
            <template v-slot:item.item_id="{ item }">
                <!-- <v-btn class="me-1" v-for="action in actions" :key="action.name" v-show="!action.show || item[action.show]" icon :color="action.color" :disabled="action.disabled && item[action.disabled]" @click="fireAction(action.name, item)">
                    <v-icon size="22">{{action.icon}}</v-icon>
                </v-btn> -->

                <!-- dots menu instead of buttons -->
                <v-menu v-if="actions && actions.length" bottom left :offset-y="true" transition="slide-y-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="muted" dark icon v-bind="attrs" v-on="on" class="me-0" style="margin-right: -12px">
                            <v-icon size="22">mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense min-width="150" >
                        <v-list-item dense v-for="(action) in actions" :key="action.name" v-show="!action.show || item[action.show]" :disabled="action.disabled && item[action.disabled]" @click="fireAction(action.name, item)">
                            <v-list-item-icon class="me-1">
                                <v-icon :color="action.color" size="19">{{action.icon}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="medium-text">{{ action.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <span v-if="item.item_id" class="ltr-dir">#{{item.item_id}}</span>

            </template>
            <template v-for="header in headers.filter(h=>(h.chip || h.time || h.price || h.boolean || h.ltr || h.money || h.number || h.image || h.avatar || h.button))" v-slot:[`item.${header.value}`]="{ item }">
                <div :key="'slot-' + header.name">
                    <v-chip v-if="header.chip" :outlined="!header.chipFunction(item[header.value]).filled" label small :color="header.chipFunction(item[header.value]).color" :dark="!!header.chipFunction(item[header.value]).color">
                        <v-icon v-if="header.chipFunction(item[header.value]).icon" size="18" class="me-2" style="margin-right: -3px">{{header.chipFunction(item[header.value]).icon}}</v-icon>
                        <strong>{{header.chipFunction(item[header.value]).text}}</strong>
                    </v-chip>
                    <div v-if="header.price || header.money" :class="{'primary--text': !!item[header.value] && !header.color, [`${header.color}--text`]: !!header.color, 'font-weight-semibold': header.weight === 'medium', 'font-weight-bold': !header.weight || header.weight === 'bold'}">
                        {{moneyFormat(item[header.value])}}
                    </div>
                    <div v-if="header.number" class="font-weight-bold" :class="{'primary--text': !!item[header.value] && !header.color, [`${header.color}--text`]: !!header.color}">
                        {{numFormat(item[header.value])}}
                    </div>
                    <div v-else-if="header.image" class="py-3">
                        <v-img centered style="border-radius: 2px" cover width="50" height="65" :src="item[header.value]" :to="header.href ? item[header.href] : ''" v-ripple="header.href ? true : false" :class="{'e-link': header.href}" />
                    </div>
                    <div v-else-if="header.avatar" class="py-3 nowrap" :style="pcOnly ? 'min-width: 300px' : ''">
                        <v-avatar :href="header.href ? item[header.href] : ''" :width="header.width || 30" :height="header.height || 30" :tile="header.tile" v-ripple="header.href ? {class: 'ripple--color'} : false" min-width="20" :class="{'e-link': header.href, 'bordered': header.bordered, [header.avatarClass]: !!header.avatarClass}" :style="header.tile ? 'border-radius: 3px!important; overflow: hidden;' : ''" @click="header.href && item[header.href] ? $router.push(item[header.href]) : undefined">
                            <v-icon v-if="header.avatarIcon" :color="header.avatarIconColor || header.color">{{item[header.avatarIcon] || header.avatarIcon}}</v-icon>
                            <v-img v-else :src="item[header.value]" ></v-img>
                        </v-avatar>
                        <component :is="header.href ? 'v-btn' : 'span'" v-if="header.avatarText" text color="primary" :to="header.href ? item[header.href] : undefined" class="ms-2 px-1" :style="header.href ? 'height: 28px' : ''">{{item[header.avatarText]}}</component>
                    </div>
                    <component v-else-if="header.button" :is="item[header.button] ? 'v-btn' : 'div'" as="v-btn" :key="'slot-' + header.value" :color="header.buttonColor || header.color || 'strong-text'" :to="item[header.button]" style="text-transform: capitalize;" class="medium-text px-3 py-4" :class="{'font-weight-bold': header.bold}" small :text="!header.filled" depressed >
                        {{item[header.value]}}
                    </component>
                    <div v-else-if="header.ltr" style="direction: ltr; text-align: right;">
                        {{item[header.value]}}
                    </div>
                    <div v-else-if="header.boolean">
                        <v-chip v-if="!!item[header.value]" color="success" dark small class="px-3">نعم</v-chip>
                        <v-chip v-else color="muted" dark small class="px-3">ﻻ</v-chip>
                    </div>
                    <div v-else-if="header.time">
                        <v-tooltip transition="fade-transition" color="tooltip" bottom>
                            <template v-slot:activator="{on, attrs}">
                                <div v-on="on" v-bind="attrs" >
                                    <v-chip small outlined label>
                                        <span class="details-text">{{timeFormat(item[header.value], true)}}</span>
                                    </v-chip>
                                </div>
                            </template>
                            <div class="ltr-dir">
                                {{dateTimeFormat(item[header.value], true)}}
                            </div>
                        </v-tooltip>
                    </div>
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <!-- <v-btn class="me-1" v-for="action in actions" :key="action.name" v-show="!action.show || item[action.show]" icon :color="action.color" :disabled="action.disabled && item[action.disabled]" @click="fireAction(action.name, item)">
                    <v-icon size="22">{{action.icon}}</v-icon>
                </v-btn> -->

                <!-- dots menu instead of buttons -->
                <v-menu bottom left :offset-y="true" transition="slide-y-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="muted" dark icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense min-width="150" >
                        <v-list-item dense v-for="(action) in actions" :key="action.name" v-show="!action.show || item[action.show]" :disabled="action.disabled && item[action.disabled]" @click="fireAction(action.name, item)">
                            <v-list-item-icon class="me-1">
                                <v-icon :color="action.color" size="19">{{action.icon}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="medium-text">{{ action.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>

            </template>
            <template v-slot:no-data>
                <div class="my-5">
                    <div class="mb-3">لم يتم العثور على بيانات...</div>
                    <v-btn v-if="searchQuery" outlined text color="primary" @click="reset">
                        <v-icon left>mdi-arrow-right</v-icon>
                        عودة للخلف
                    </v-btn>
                </div>
            </template>
        </v-data-table>

        <div v-if="serverPagination && pageCount > 1">
            <v-pagination color="primary" circle :total-visible="pcOnly ? 10 : 4" v-model="page" :length="pageCount" ></v-pagination>
        </div>

        <v-dialog v-if="exportUrl" v-model="exportDialog" max-width="290" overlay-color="#000" overlay-opacity="0.6">
            <v-card>
                <v-card-title class="mb-2 px-4">استخراج إلى إكسيل</v-card-title>
                <v-card-subtitle class=" px-4">استخراج بيانات الجدول إلى ملف إكسيل</v-card-subtitle>
                <v-card-text class="pb-3 px-4">
                    <v-btn absolute top left icon color="muted" @click="exportDialog = false;">
                        <v-icon size="20">mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="green darken-1" block dark depressed @click="openExportUrl">
                        <v-icon left>mdi-file-export</v-icon>
                        استخراج
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props:{
        title: String,
        headers: {},
        items: {},
        hideCreate: {type: Boolean, default: false},
        showSearch: {type: Boolean, default: false},
        createButtonText: {type: String, default: 'Add New'},
        createButtonIcon: {type: String, default: 'mdi-plus-circle-outline'},
        searchPlaceholder: {type: String, default: 'Search in items...'},
        actions: Array,

        serverPagination: {type: Boolean, default: false},
        pageCount: {type: Number, default: 1}, // how many pages (last_page)
        currentPage: {type: Number, default: 1},
        perPage: {type: Number, default: 20},
        total: {type: Number},
        loading: {type: Boolean, default: false},
        exportUrl: {},
    },
    data() {
        return {
            page: 0,
            searchQuery: '',
            exportDialog: false,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {
        page(page, old){
            if (old > 0){
                const query = this.searchQuery;
                this.$emit('load', {page, query});
            }
        },
        dialog (val) {
            val || this.close()
        },
        dialogDelete (val) {
            val || this.closeDelete()
        },
        currentPage(page){
            this.page = page;
        }
    },
    methods: {
        ...GlobalMethods,
        fireAction(action, item) {
            this.$emit(action, item);
        },
        search(){
            this.$refs.searchInput.blur();
            this.$emit('search', this.searchQuery);
        },
        reset(){
            if (this.searchQuery){
                this.searchQuery = '';
            }
            this.$emit('reset');
        },
        openExportUrl(){
            const token = window.localStorage.getItem('tK');
            const url = this.exportUrl + '?api_token=' + token;
            window.open(url, '_system');
        }
    },
    mounted(){
        this.page = this.currentPage;

        const queryParam = new URLSearchParams(window.location.search).get('search');
        if (queryParam){
            this.searchQuery = queryParam;
        }
    }
}

</script>

<style lang="scss" scoped>
    section {
        .headline {
            font-size: 2rem !important;
            line-height: 3rem !important;
        }

        .description {
            line-height: 2rem !important;
        }
    }

    @media(max-width: 960px) {
        section {

            .headline {
                font-size: 1.65rem !important;
                line-height: 2.7rem !important;
            }

            .actions,
            .headline,
            .description {
                text-align: center;
                justify-content: center;
            }
        }
    }

</style>
<style lang="scss">
.crud-table{
    .e-data-table{
        tr{
            white-space: nowrap;
            th{
                font-weight: normal;

                &[aria-label="معرف"], &[aria-label="#"]{
                    width: 90px;
                }
            }
            td{
                max-width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .v-input input{
        font-size: 14px!important;
        line-height: 1;
    }
}
</style>
